import { unwrapResult } from '@reduxjs/toolkit';
import { RadioChangeEvent } from 'antd/lib/radio';
import React, { FC, useState } from 'react';
import styled from 'styled-components';

import { MethodPayment, Methods } from '~/api/finance/financeApiTypes';
import { LoaderIcon } from '~/atomic/atom/icon/LoaderIcon';
import { TrashIcon } from '~/atomic/atom/icon/TrashIcon';
import { Radio } from '~/atomic/atom/Radio';
import { TextRegStyle } from '~/atomic/Typography';
import { unLinkBankCard } from '~/feature/finance/BuyingSteps/ChoosePay/choosePay.data';
import { useAppDispatch } from '~/store';

export interface MethodChoose {
  type: Methods;
  cardId: number;
}

interface PaymentMethodProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> {
  method: MethodPayment;
  activeMethod: MethodChoose;
  price: number;
  onChange: (e: RadioChangeEvent) => void;
}

export const PaymentMethod: FC<PaymentMethodProps> = ({
  method, activeMethod, price, onChange, ...styleProps
}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const saveCard = 'card' in method ? method : undefined;
  const isSaveCard = !!saveCard?.card;
  const isHaveSaveCard = !!(activeMethod?.cardId);

  const isChecked = isHaveSaveCard
    ? activeMethod?.cardId === saveCard?.card?.id
    : activeMethod.type === method.type && !saveCard?.card?.id;

  const isBlocked = method.type === Methods.balance && method?.sum < price;

  const deleteSaveCardHandler = (e) => {
    e.stopPropagation();
    if (saveCard?.card?.id && !loading) {
      setLoading(true);
      dispatch(unLinkBankCard({ bankCardId: saveCard.card.id }))
        .then(unwrapResult)
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <SCPaymentMethod
      {...styleProps}
    >
      <SCRadio
        name="method"
        value={{ type: method.type, cardId: saveCard?.card?.id }}
        checked={isChecked}
        disabled={isBlocked}
        onChange={onChange}
      >
        {method.name}
      </SCRadio>
      {isSaveCard && !loading && (
        <SCDeleteSaveCard
          onClick={deleteSaveCardHandler}
        />
      )}
      {loading && (
        <SCLoaderIcon />
      )}
    </SCPaymentMethod>
  );
};

const SCRadio = styled(Radio)`
  span {
    ${TextRegStyle};
    color: var(--black-color);

    
    &[data-disabled="true"] {
      color: var(--gray-color);
    }
  }
`;

export const SCPaymentMethod = styled.div`
  display: flex;
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  padding: 8px;

  &:not(:last-child) {
    margin-bottom: 4px;
  }
`;

const SCDeleteSaveCard = styled(TrashIcon)`
  font-size: 20px;
  color: var(--gray-color);
  margin-left: auto;
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    color: var(--primary-hover-color);
  }
`;

const SCLoaderIcon = styled(LoaderIcon)`
  width: 20px;
  height: 20px;
  fill: var(--gray-color);
  margin-left: auto;
  transition: fill 0.3s;
  cursor: pointer;

  &:hover {
    fill: var(--primary-hover-color);
  } 
`;
